module.exports = __webpack_public_path__ + "img/shouye-xiazai.9020c8a1.jpg";